import { Button } from '@workramp/ui';
import styled from 'styled-components';

// StyledButton is required to remove the padding from the Button component
// Added to it by default
export const StyledButton = styled(Button)`
  padding-left: 0;
`;
